import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import cNames from '../../../Utility/utility';
import { putData } from "../../../Core/Projects/action";
import { changeData, unchangeData } from '../../../Core/ChangeValues/action';
import QuestionIcon from '../../../Assets/Images/question.svg';
import styles from '../../../Assets/Styles/Components/Book/Packages/Card.module.css';

class Card extends Component {
	constructor(props) {
		super(props);
		// Users who reach this step without picking a package outside /book are
		// seeing the levels for the first time, so reveal them one at a time —
		// same progressive disclosure as the landing pages.
		this.state = { revealedGrades: 1 };
	}

	onClick = (id) => () => {
		const { slug, data } = this.props.project;
		this.props.putData(slug, { ...data, package_id: id, step: this.props.history.location.pathname.slice(1).split('/')[1] });
		this.props.changeData();
	};

	revealLowerGrade = () => {
		this.setState((prev) => ({ revealedGrades: prev.revealedGrades + 1 }));
	};

	render() {
		const { activeHour, selectedPack, direct, order, is_gold: isGold, title, is_full: isFull, digitals, price, grade_prices, id, features, kenar_divar, singlePrice, extraPrice, extension_prices: extensionPrices = [] } = this.props;
		const { revealedGrades } = this.state;
		let cardStyle = '';
		// Single-price shoot types are not billed per grade: the extension is the
		// flat shoot_type.half_hour_extend_cost the API sends as extra_price.
		const flatExtensionPrice = singlePrice ? Number(extraPrice) || 0 : 0;
		const showExtensionPrices = !kenar_divar && (singlePrice ? flatExtensionPrice > 0 : extensionPrices.length !== 0);
		// Most expensive first: it is what the landing pages show by default and
		// what three quarters of bookings actually land on.
		const gradePrices = (grade_prices || []).slice().sort((a, b) => Number(b.price) - Number(a.price));
		const isSinglePrice = gradePrices.length === 1 && gradePrices[0].title === '';
		const visibleGrades = gradePrices.slice(0, revealedGrades);
		const hasHiddenGrades = !isSinglePrice && revealedGrades < gradePrices.length;
		if (order !== activeHour) {
			cardStyle = styles.hidden;
		} else if (isGold) {
			cardStyle = styles.gold;
		}
		return (
			<div key={id} className={cNames(styles.packageCard, cardStyle)}>
				<h3 className={styles.title}>
					{title}
				</h3>
				<div className={styles.items}>
					{/* <div className={styles.item}>
						<p>میانگین <b>{averageFrames} عکس</b></p>
					</div> */}
					<div className={styles.item}>
						<p><i className="fas fa-check" /> ادیت نور و رنگ رایگان</p>
					</div>
					<div className={styles.item}>
						<p><i className="fas fa-check" /> امکان دانلود<b>{isFull ? ' همه فایل ها ' : ` ${digitals} فایل `}</b>	</p>
					</div>
					{features.map((a, index) => (
						<div key={`${id}-feature-${index}`} className={cNames(styles.item, styles.kenar_divar)}>
							<p><i className="fas fa-check" />{a}</p>
						</div>
					))}
					{!kenar_divar && features.length !== 0 &&
						<div
							className={cNames(styles.item, styles.actionItem)}
							onClick={() => {
								const pack = { title, features, duration: order };
								this.props.onMore(pack);
							}}
						>
							<img src={QuestionIcon} alt="question" className={styles.icon} />
							<p className={styles.moreInfo}>اطلاعات بیشتر ... </p>
						</div>}
					{showExtensionPrices &&
						<div
							className={cNames(styles.item, styles.actionItem)}
							onClick={() => {
								const pack = { title, duration: order, extensionPrices, flatExtensionPrice };
								this.props.onExtensionPrices(pack);
							}}
						>
							<img src={QuestionIcon} alt="question" className={styles.icon} />
							<p className={styles.moreInfo}>هزینه تمدید ساعت بیشتر.</p>
						</div>}
				</div>
				<div className={styles.price}>
					{!kenar_divar &&
					<div className={styles.priceBox}>
						{direct && <div className={`${styles.baseCostDiv} `}><p className={`${styles.baseCostFrom} `}>هزینه پکیج</p><p className={`${styles.baseCost} `}>{new Intl.NumberFormat().format(Number(price))} تومان </p></div>}
						{!direct && visibleGrades.map((a, index) => (
						<div key={`${id}-grade-${index}`} className={`${styles.baseCostDiv}`} style={isSinglePrice ? { justifyContent: 'flex-end' } : {}}>
							{!isSinglePrice && (
							<p className={`${styles.baseCostFrom}`}>{a.title}</p>
							)}
							<p className={`${styles.baseCost}`} style={isSinglePrice ? { fontSize: '22px' } : {}}>
							{new Intl.NumberFormat().format(Number(a.price))} تومان
							</p>
						</div>
						))}
						{!direct && hasHiddenGrades && (
						<button type="button" className={`${styles.revealLowerGrade}`} onClick={this.revealLowerGrade}>
							{revealedGrades === 1 ? 'قیمت کمتر هم دارید؟' : 'یک سطح ارزان‌تر دیگر'}
						</button>
						)}
						{!direct && !isSinglePrice && (
						<p className={`${styles.finalPriceNote}`}>
							قیمت نهایی وابسته به متخصصی که انتخاب می‌کنید است
						</p>
						)}
					</div>}
					<div type="button" className={`${styles.button} ${selectedPack === id ? styles.selected : ''}`} onClick={this.onClick(id)}>{selectedPack === id ? 'انتخاب شده' : 'انتخاب و ادامه'}<i className="fa fa-arrow-left" aria-hidden="true" style={{ marginRight: '5px' }}> </i></div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		state,
		project: state.project
	};
};
export default connect(mapStateToProps, { putData, changeData, unchangeData })(withRouter(Card));
